






























































































































import { Vue, Component, Prop, Watch, Ref } from 'vue-property-decorator'
import RevealPasswordField from '@/components/ui/RevealPasswordField.vue'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import { obrigatorio } from '@/shareds/regras-de-form'
import { montarOperacaoDeRecurso } from '@/shareds/permissoes-shareds'
import { dateTimeToPtBrFormat } from '@/shareds/date/date-utils'
import {
	buscarIntegracaoDeEmail,
	enviarEmailDeTeste,
	salvarIntegracaoDeEmail,
} from '@/api/integracaoDeEmail'
import { DadosDaIntegracaoDeEmail, IntegracaoDeEmailDaLoja } from '@/models/email/EnvioDeEmail'

const FORMATO_DE_EMAIL = /^[^@\s]+@[^@\s]+\.[^@\s]+$/

@Component({
	components: { RevealPasswordField },
})
export default class TabDeEnvioDeEmail extends Vue {
	@Prop({ type: String, default: '' }) lojaId!: string
	@Ref() formDeTeste!: HTMLFormElement

	obrigatorio = obrigatorio
	integracao: IntegracaoDeEmailDaLoja | null = null
	form: DadosDaIntegracaoDeEmail = this.formVazio()
	carregando = false
	testando = false
	dialogoDeTeste = false
	destinatarioDoTeste = ''

	emailValido = (valor: string) => !valor || FORMATO_DE_EMAIL.test(valor.trim()) || 'E-mail precisa ser válido'

	// Lido do login, não do ref da edição da loja: na loja nova o ref ainda não existe na primeira renderização.
	get podeEditar() {
		return UserLoginStore.temAutorizacao(montarOperacaoDeRecurso('alterar', 'lojas'))
	}

	get configurado() {
		return !!(this.integracao?.possuiChaveApi || this.integracao?.emailDeEnvio)
	}

	get preenchido() {
		return !!(this.form.emailDeEnvio?.trim() || this.form.chaveApi?.trim() || this.form.nomeDoRemetente?.trim())
	}

	get regrasDoEmailDeEnvio() {
		if (!this.configurado && !this.preenchido) return []
		return [obrigatorio, this.emailValido]
	}

	get regrasDaChaveApi() {
		if (this.integracao?.possuiChaveApi || (!this.configurado && !this.preenchido)) return []
		return [obrigatorio]
	}

	get dadosDeEnvioMudaram() {
		if (!this.integracao) return false
		const emailMudou = (this.form.emailDeEnvio || '').trim().toLowerCase()
			!== (this.integracao.emailDeEnvio || '').trim().toLowerCase()
		return emailMudou || !!this.form.chaveApi?.trim()
	}

	get testeValido() {
		return !!this.integracao?.testeAprovado && !this.dadosDeEnvioMudaram
	}

	get testeAprovadoEmFormatado() {
		return this.integracao?.testeAprovadoEm ? dateTimeToPtBrFormat(this.integracao.testeAprovadoEm) : ''
	}

	get alterado() {
		if (!this.integracao) return false
		return this.dadosDeEnvioMudaram
			|| (this.form.nomeDoRemetente || '') !== (this.integracao.nomeDoRemetente || '')
			|| this.form.envioAtivo !== this.integracao.envioAtivo
			|| this.form.enviarXmlJuntoComPdf !== this.integracao.enviarXmlJuntoComPdf
	}

	@Watch('lojaId', { immediate: true })
	async carregar() {
		this.integracao = null
		this.form = this.formVazio()
		if (!this.lojaId) return
		try {
			this.carregando = true
			this.aplicar(await buscarIntegracaoDeEmail(this.lojaId))
		} catch (error) {
			AlertModule.setError(error)
		} finally {
			this.carregando = false
		}
	}

	@Watch('testeValido')
	onChangeTesteValido(valido: boolean) {
		if (!valido) this.form.envioAtivo = false
	}

	async salvar() {
		if (!this.lojaId || !this.integracao || !this.alterado) return
		if (!this.configurado && !this.preenchido) return
		this.aplicar(await salvarIntegracaoDeEmail(this.lojaId, this.dadosParaEnviar()))
	}

	abrirDialogoDeTeste() {
		if (!this.form.emailDeEnvio?.trim() || !FORMATO_DE_EMAIL.test(this.form.emailDeEnvio.trim())) {
			AlertModule.setError('Informe um e-mail de envio válido antes do teste.')
			return
		}
		if (!this.form.chaveApi?.trim() && !this.integracao?.possuiChaveApi) {
			AlertModule.setError('Informe a chave da API antes do teste.')
			return
		}
		this.destinatarioDoTeste = this.destinatarioDoTeste || UserLoginStore.usuario?.email || ''
		this.dialogoDeTeste = true
	}

	async enviarTeste() {
		if (!this.formDeTeste.validate()) return
		try {
			this.testando = true
			const envioAtivo = this.form.envioAtivo
			const testada = await enviarEmailDeTeste(this.lojaId, {
				...this.dadosParaEnviar(),
				destinatario: this.destinatarioDoTeste.trim(),
			})
			this.aplicar(testada)
			this.form.envioAtivo = envioAtivo && testada.testeAprovado
			this.dialogoDeTeste = false
			AlertModule.setSuccess(
				`E-mail de teste enviado para ${this.destinatarioDoTeste.trim()}. `
				+ 'Ligue "Enviar e-mails ao cliente" e salve a loja para começar a enviar.',
			)
		} catch (error) {
			AlertModule.setError(error)
		} finally {
			this.testando = false
		}
	}

	private aplicar(integracao: IntegracaoDeEmailDaLoja) {
		this.integracao = integracao
		this.form = {
			emailDeEnvio: integracao.emailDeEnvio || '',
			nomeDoRemetente: integracao.nomeDoRemetente || '',
			chaveApi: '',
			envioAtivo: integracao.envioAtivo,
			enviarXmlJuntoComPdf: integracao.enviarXmlJuntoComPdf,
		}
	}

	private dadosParaEnviar(): DadosDaIntegracaoDeEmail {
		return {
			emailDeEnvio: (this.form.emailDeEnvio || '').trim(),
			nomeDoRemetente: this.form.nomeDoRemetente?.trim() || null,
			chaveApi: this.form.chaveApi?.trim() || null,
			envioAtivo: this.form.envioAtivo,
			enviarXmlJuntoComPdf: this.form.enviarXmlJuntoComPdf,
		}
	}

	private formVazio(): DadosDaIntegracaoDeEmail {
		return {
			emailDeEnvio: '',
			nomeDoRemetente: '',
			chaveApi: '',
			envioAtivo: false,
			enviarXmlJuntoComPdf: false,
		}
	}
}
